function modeLabel(mode) {
    const normalized = String(mode || "").toLowerCase();
    if (normalized === "live") return "Live";
    if (normalized === "paper") return "Paper";
    if (normalized === "dry_run" || normalized === "dry") return "Dry";
    return "Unknown";
}

function countModes(state, engines, engineCoins) {
    const counts = {};
    engines.forEach((engine) => {
        const coins = engineCoins?.[engine.coinsKey] || [];
        coins.forEach((coin) => {
            const mode = state?.engines?.[engine.key]?.[coin] || state?.globalMode;
            const label = modeLabel(mode);
            counts[label] = (counts[label] || 0) + 1;
        });
    });
    return counts;
}

export default function summarizeEngineRuntimeModes(state, engines = [], engineCoins = {}) {
    if (!state || !engines?.length) return "Modes unavailable";
    const counts = countModes(state, engines, engineCoins);
    const entries = Object.entries(counts);
    if (!entries.length) return "No modes configured";
    if (entries.length === 1) {
        const [[label]] = entries;
        return `All engines in ${label} mode`;
    }

    const majority = entries.reduce((acc, [label, value]) => {
        if (!acc || value > acc.count) return { label, count: value };
        return acc;
    }, null);

    const majorityLabel = majority?.label || "Paper";
    const notable = [];

    engines.forEach((engine) => {
        const coins = engineCoins?.[engine.coinsKey] || [];
        const modes = coins.map((coin) => state?.engines?.[engine.key]?.[coin] || state?.globalMode);
        const unique = Array.from(new Set(modes.map(modeLabel)));
        if (unique.length === 1 && unique[0] !== majorityLabel) {
            notable.push(`${engine.label} ${unique[0].toLowerCase()}`);
            return;
        }
        const liveCoins = coins.filter((coin) =>
            modeLabel(state?.engines?.[engine.key]?.[coin] || state?.globalMode) === "Live",
        );
        if (liveCoins.length === 1) {
            notable.push(`${liveCoins[0]} live on ${engine.label}`);
        }
    });

    if (notable.length === 1) return `${notable[0]}; others ${majorityLabel.toLowerCase()}`;
    if (notable.length > 1) return notable.join(" • ");
    return `${majorityLabel} with mixed overrides`;
}

export { modeLabel };
